/* eslint-disable @next/next/no-img-element */
import React, { useContext, useState, useEffect } from "react";
import PrivateTreatyCard from "./PrivateTreatyCard";
import { Button } from "../../../shadcn/components/ui/button";
import {
  amountFormatter,
  Context,
  getSearchResults,
  getWatermarkedImgixUrl,
} from "services";
import { DateTime } from "luxon";
import { useRouter } from "next/router";

interface privateTreatyItems {
  title?: string;
  price?: string;
  address?: string;
  imageLink?: string;
  auctionDate?: string;
  bankName?: string;
  bankLogo?: React.ReactNode;
  propertyLink?: string;
  propertyDateType?: string;
}

const bankName = process.env.NEXT_PUBLIC_BANK;

export default function PrivateTreatySection() {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const [privateTreaty, setPrivateTreaty] = useState<privateTreatyItems[]>([]);
  const [isPropertyFounded, setIsPropertyFounded] = useState<boolean>(false);
  const init = async () => {
    const data: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          query_by: "",
          // facet_by: "dump.location.locality_slug",
          // facet_return_parent: "dump.location.locality_slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=private_treaty && dump.location.city_name:${searchForm.value.city.label} && dump.bank.bank_slug:${bankName}`,
          max_facet_values: "100",
          per_page: 4,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
        {
          collection: "properties",
          q: "*",
          query_by: "",
          // facet_by: "dump.location.locality_slug",
          // facet_return_parent: "dump.location.locality_slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=private_treaty && dump.asset.asset_type_slug:=${searchForm.value.asset_type.value} && dump.bank.bank_slug:${bankName}`,
          max_facet_values: "100",
          per_page: 4,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
        {
          collection: "properties",
          q: "*",
          query_by: "",
          // facet_by: "dump.location.locality_slug",
          // facet_return_parent: "dump.location.locality_slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=private_treaty && dump.bank.bank_slug:${bankName}`,
          max_facet_values: "100",
          per_page: 4,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
      ],
    });

    const allPrivateTreatyAuctionProperties =
      [
        ...(data.results[0]?.hits || []),
        ...(data.results[1]?.hits || []),
        ...(data.results[2]?.hits || []),
      ].map((hit: any) => ({
        title: hit.document.borrower_name ? hit.document.borrower_name : "",
        price: hit.document.reserve_price,
        address: hit.document?.address?.split(" ").slice(0, 10).join(" "),
        imageLink: hit.document?.dump?.property_image
          ? getWatermarkedImgixUrl(
              `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit.document?.dump?.property_image}`,
            )
          : hit.document?.dump?.asset?.placeholder_image
          ? getWatermarkedImgixUrl(
              `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit?.document?.dump?.asset?.placeholder_image}`,
            )
          : "/residential1.png",
        auctionDate: DateTime.fromISO(hit.document.auction_start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy"),
        bankName: hit?.document?.dump?.bank?.bank_name,
        bankLogo: hit?.document?.dump?.bank?.bank_logo ? (
          <img
            src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit.document.dump.bank.bank_logo}?w=22&h=22&dpr=2&auto=format`}
            alt={`${hit?.document?.dump?.bank?.bank_name} Logo`}
          />
        ) : (
          <p className="bg-brand-orange rounded-full flex justify-center items-center h-6 w-6 font-openSans font-semibold uppercase text-web-body-sm leading-4 text-white py-2">
            {hit?.document?.dump?.bank?.bank_name?.charAt(0)}
          </p>
          // <HDFCLogo height="22px" width="22px" />
        ),
        propertyLink: `/auction-properties/${hit.document.listing_id}`,
        propertyDateType: hit.document.property_date_type,
        locality: `${hit.document.dump?.location?.city_name},${hit.document.dump?.location?.state_name}`,
        sub_asset_type_name: hit.document?.dump?.asset?.sub_asset_type_name,
        listing_id: hit.document?.listing_id,
      })) || [];
    const newPrivateTreatyAuctionProperties =
      allPrivateTreatyAuctionProperties.filter(
        (prop, index, self) =>
          prop.listing_id &&
          index === self.findIndex((p) => p.listing_id === prop.listing_id),
      );

    setPrivateTreaty(newPrivateTreatyAuctionProperties);
    if (data?.results?.[0]?.hits?.length > 0) {
      setIsPropertyFounded(true);
    } else {
      setIsPropertyFounded(false);
    }
  };
  useEffect(() => {
    (async () => {
      await init();
    })();
  }, [searchForm.value.city]);

  const cardOnClickHandler = (id: any) => {
    router.push(`/auction-properties/${id}`);
  };

  return (
    <>
      {privateTreaty && privateTreaty.length > 0 && (
        <div className="w-full px-3 lg:px-8 py-8 grid grid-cols-1 gap-4 md:grid-cols-2 justify-center items-center bg-gradient-to-b from-[rgba(241,241,241,0.6)] to-[rgba(255,255,255,0)]">
          <div className="order-1 mb-6">
            <h3 className="text-[28px] lg:text-[32px] font-normal leading-normal uppercase text-brand-textBlack">
              Private Treaty Auctions
            </h3>
          </div>
          <div className="order-2 md:order-3 md:col-span-2 flex overflow-x-scroll">
            <div className="flex gap-6">
              {/* <PrivateTreatyCard />
          <PrivateTreatyCard />
          <PrivateTreatyCard /> */}
              {privateTreaty.map((item: any, index: number) => (
                // <ComingSoonAuctionCard
                //   price={item.price}
                //   subAssetType={item.sub_asset_type_name}
                //   imageLink={item?.imageLink}
                //   address={item.locality}
                //   propertyLink={item.propertyLink}
                //   styles={{
                //     linkStyle: "bg-white py-4 px-2",
                //     subAssetStyle: "bg-[#F1EAFF]",
                //     priceStyle: "lg:text-base",
                //   }}
                //   key={`upcoming_prop_${index}`}
                // />
                <PrivateTreatyCard
                  key={`PrivateTreatyCard-${index}`}
                  price={amountFormatter(item.price)}
                  propertySubType={item.sub_asset_type_name}
                  auctionDate={"Private Treaty"}
                  sellerName={item.bankName}
                  listingId={item.listing_id}
                  onClickHandler={cardOnClickHandler}
                  imageSrc={item.imageLink}
                  sellerLogo={item.bankLogo}
                />
              ))}
            </div>
          </div>
          <Button
            className="order-3 md:justify-self-end md:order-2 flex lg:block justify-center text-black bg-white border-[1px] hover:bg-white hover:shadow-md"
            onClick={() => {
              if (isPropertyFounded && searchForm.value?.city?.value) {
                router.push(
                  `/auction-properties-in-${searchForm.value.city.value}?filter_by=private_treaty`,
                );
              } else {
                searchForm.setField("city", { label: "All Cities", value: "" });
                router.push(`/auction-properties?filter_by=private_treaty`);
              }
            }}
          >
            View all
          </Button>
        </div>
      )}
    </>
  );
}
